/* ------------------------------------------------------------------
   Free shipping / shipping info
   让购物车页进度条与商品页提示始终跟随实时购物车。

   第 15 轮修正（2026-10-17）：
     · 百分比与差额改为【只按购物车实际金额】计算；
       商品页当前选中的商品不再预支进购物车。
       根因：空车浏览一件 $108 的商品时显示 "Add $42 more / 72%"，
       正确应为 "Free shipping on orders over $150 / 0%"。
       previewExtra 仅保留给「Add this item to get free shipping」的文案判断。

   第 8 轮修正（2026-10-17）：
     · 修复「空购物车打开一个高价商品页 → 直接显示免运已解锁」
       根因：预估金额被当成已达成。现区分「购物车真达标」与「加上这件才达标」。
     · 商品已在购物车里时，扣掉同变体已有数量，不再重复累加
     · 变体匹配失败直接返回 0，不再拿第一个变体的价格顶替
     · 全程 isFinite 保护，任何异常数据都不会算出 NaN%
     · ShopifyAnalytics 的 price 是「分」；个别 app 会输出 {amount}（元），两种都兼容

   依赖：无。用 Dawn 的 cart-update pubsub，失败时回落到 DOM 观察。
   加载方式：defer
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var SEL = '[data-free-shipping]';
  var started = false;
  var pubsubBound = false;
  var cartCache = null;
  var fetching = null;
  var timer = null;

  /* ---------- helpers ---------- */

  function num(v) {
    var n = typeof v === 'number' ? v : parseFloat(v);
    return isFinite(n) ? n : 0;
  }

  /* ShopifyAnalytics 的 price 是「分」（如 19900）；
     少数 app 输出 { amount: 199.0, currencyCode } 是「元」。两种都兼容。 */
  function priceToCents(p) {
    if (p == null) return 0;
    if (typeof p === 'number') return isFinite(p) ? p : 0;
    if (typeof p === 'object' && isFinite(p.amount)) return Math.round(p.amount * 100);
    return 0;
  }

  function fmt(cents, currency) {
    var v = num(cents) / 100;
    var whole = Math.abs(v - Math.round(v)) < 0.005;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || 'USD',
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: whole ? 0 : 2
      }).format(v);
    } catch (e) {
      return '$' + (whole ? Math.round(v) : v.toFixed(2));
    }
  }

  function productForm() {
    return (
      document.querySelector('form[data-type="add-to-cart-form"]') ||
      document.querySelector('product-form form') ||
      document.querySelector('form[id^="product-form"]') ||
      null
    );
  }

  /* Dawn 的数量输入框放在 form 之外，靠 form="<id>" 关联，所以要先按 form id 找 */
  function qtyInput(form) {
    if (form && form.id) {
      var byForm = document.querySelector('input[name="quantity"][form="' + form.id + '"]');
      if (byForm) return byForm;
    }
    return (
      (form && form.querySelector('input[name="quantity"]')) ||
      document.querySelector('.product-form__quantity input[name="quantity"]') ||
      document.querySelector('input[name="quantity"]') ||
      null
    );
  }

  /* 商品页：当前选中规格 × 数量，扣掉购物车里同变体已有的数量，避免重复累加 */
  function previewExtra(el, cart) {
    if (el.getAttribute('data-estimate') !== 'true') return 0;
    try {
      var meta =
        window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
      if (!meta || !meta.variants || !meta.variants.length) return 0;

      var form = productForm();
      var vid = 0;
      if (form) {
        var idEl = form.querySelector('input[name="id"]');
        if (idEl) vid = num(idEl.value);
      }
      if (!vid) {
        var m = /[?&]variant=(\d+)/.exec(window.location.search);
        if (m) vid = num(m[1]);
      }
      if (!vid && meta.variants[0]) vid = num(meta.variants[0].id);

      var pick = null;
      for (var i = 0; i < meta.variants.length; i++) {
        if (num(meta.variants[i].id) === vid) {
          pick = meta.variants[i];
          break;
        }
      }
      if (!pick) return 0;

      var qEl = qtyInput(form);
      var qty = qEl ? parseInt(qEl.value, 10) : 1;
      if (!isFinite(qty) || qty < 1) qty = 1;

      var inCart = 0;
      var items = (cart && cart.items) || [];
      for (var j = 0; j < items.length; j++) {
        if (num(items[j].variant_id) === vid) inCart += num(items[j].quantity);
      }
      var addQty = Math.max(0, qty - inCart);
      return addQty * priceToCents(pick.price);
    } catch (e) {
      return 0;
    }
  }

  /* 底部「运费与时效」随达标状态切换文案 */
  function setNote(el, noteEl, which) {
    if (!noteEl) return;
    var v = el.getAttribute('data-note-' + which);
    if (v) noteEl.textContent = v;
  }

  /* ---------- render ---------- */

  function paint(cart) {
    var nodes = document.querySelectorAll(SEL);
    if (!nodes.length) return;

    var currency = (cart && cart.currency) || 'USD';
    var cartTotal = Math.max(0, num(cart && cart.total_price));

    Array.prototype.forEach.call(nodes, function (el) {
      var threshold = num(el.getAttribute('data-threshold'));
      if (threshold <= 0) return;

      var extra = previewExtra(el, cart);
      var projected = cartTotal + extra;

      var msgEl = el.querySelector('.fs-msg');
      var pctEl = el.querySelector('.fs-pct-num');
      var noteEl = el.querySelector('.fs-note');

      /* 只有「购物车真实金额已达门槛」才算解锁 */
      var unlocked = cartTotal >= threshold;
      var pct = 0;
      var html = '';

      /* 进度与差额一律只按【购物车实际金额】计算。
         商品页当前选中的那件还没有加进购物车，绝不能预支：
         空车看一件 $108 的商品，曾经显示 "Add $42 more / 72%"，
         正确结果是 "还差 $150 / 0%"。
         projected 只保留给「加这件就免运」的文案判断，不参与任何金额。 */
      var pctOfCart = Math.max(0, Math.min(99, Math.floor((cartTotal / threshold) * 100)));

      if (unlocked) {
        pct = 100;
        html = el.getAttribute('data-msg-unlocked') || '';
      } else if (cartTotal <= 0) {
        /* 购物车为空：只说明门槛，不提差额 */
        pct = 0;
        html = el.getAttribute('data-msg-empty') || '';
      } else if (projected >= threshold) {
        /* 购物车已有金额，加当前这件刚好够门槛 —— 只做文案提示，进度仍按购物车 */
        pct = pctOfCart;
        html =
          el.getAttribute('data-msg-additem') || 'Add this item to get free shipping';
      } else {
        pct = pctOfCart;
        html = (el.getAttribute('data-msg-remaining') || '')
          .split('[[amount]]')
          .join('<strong>' + fmt(threshold - cartTotal, currency) + '</strong>');
      }

      if (!isFinite(pct)) pct = 0;

      if (unlocked) el.classList.add('is-unlocked');
      else el.classList.remove('is-unlocked');

      setNote(el, noteEl, unlocked ? 'free' : 'paid');

      if (msgEl) msgEl.innerHTML = html;
      if (pctEl) pctEl.textContent = String(pct);
      el.style.setProperty('--fs-progress', pct + '%');
      el.setAttribute('aria-valuenow', String(pct));
      el.setAttribute('aria-valuetext', msgEl ? msgEl.textContent : '');
    });
  }

  /* ---------- cart fetch ---------- */

  function refresh() {
    if (fetching) return fetching;
    fetching = fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (c) {
        fetching = null;
        if (c) {
          cartCache = c;
          paint(c);
        }
      })
      .catch(function () {
        fetching = null;
      });
    return fetching;
  }

  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(refresh, 120);
  }

  /* 不重新请求，只用本地缓存的购物车重算（改数量/换规格时用） */
  function repaintLocal() {
    paint(cartCache || { total_price: 0, items: [] });
  }

  /* ---------- wiring ---------- */

  function bindPubsub() {
    if (pubsubBound) return true;
    try {
      if (typeof subscribe === 'function') {
        var evt =
          (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) || 'cart-update';
        subscribe(evt, schedule);
        pubsubBound = true;
        return true;
      }
    } catch (e) {}
    return false;
  }

  function observeCart() {
    if (typeof MutationObserver !== 'function') return;
    var host =
      document.querySelector('#main-cart-items') ||
      document.querySelector('.cart__items') ||
      document.querySelector('cart-items');
    if (!host) return;
    new MutationObserver(schedule).observe(host, { childList: true, subtree: true });
  }

  function start() {
    if (started) return;
    started = true;

    bindPubsub();
    observeCart();

    /* 商品页：改数量 / 换规格时即时联动 */
    document.addEventListener(
      'change',
      function (e) {
        var t = e.target;
        if (t && (t.name === 'quantity' || t.name === 'id')) repaintLocal();
      },
      true
    );
    document.addEventListener(
      'input',
      function (e) {
        var t = e.target;
        if (t && t.name === 'quantity') repaintLocal();
      },
      true
    );

    /* 其他主题/应用可能派发的原生事件，作为额外兜底 */
    document.addEventListener('cart:updated', schedule);
    window.addEventListener('pageshow', schedule);

    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      start();
      bindPubsub();
    });
  } else {
    start();
  }
})();
